var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartNotiSide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16275 13.2135L10.3238 19.7065C11.5068 20.9532 13.4932 20.9532 14.6762 19.7065L20.8372 13.2135C23.0542 10.877 23.0543 7.08883 20.8373 4.75235C18.6203 2.41588 15.0258 2.41588 12.8088 4.75236C12.6409 4.92926 12.3591 4.92926 12.1912 4.75236C9.97421 2.41588 6.37975 2.41588 4.16275 4.75236C1.94575 7.08883 1.94575 10.877 4.16275 13.2135Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartNotiSide);
export default __webpack_public_path__ + "static/media/HeartNotiSide.c48dc0139f8417c1fa1934d8d4d02dd2.svg";
export { ForwardRef as ReactComponent };